<template>
  <div
    class="l-image-container"
    :style="{ 'overflow-y': isScroll ? 'auto' : 'hidden' }"
  >
    <img 
      class="l-image" 
      :src="url" 
      :style="{ 'height': isScroll ? 'auto' : '100%' }" 
    />
  </div>
</template>

<script>
export default {
  name: 'l-image',
  props: {
    url: {
      type: String,
      deep: true
    },
    isScroll: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="stylus" scoped>
@import './index.styl'
</style>
